module.exports = __webpack_public_path__ + "static/fonts/NotoSansKR-Light.69a7091.otf";


//////////////////
// WEBPACK FOOTER
// ./src/views/nca/css/font/NotoSansKR-Light.otf
// module id = h+G8
// module chunks = 0